// src/components/FeaturesSection.js
import React from "react";
import "./FeaturesSection.css";

const FeaturesSection = () => {
  return (
    <section className="features-section">
      {/* First Section */}
      <div className="feature-row">
        <div className="feature-left light">
          <p>
            La cocina abierta al comedor y al salón crea un ambiente
            <br />
            de amplitud y fluidez en el espacio habitable.
          </p>
        </div>
        <div className="feature-right bold">
          <p>Amplitud & Fluidez</p>
        </div>
      </div>

      <div className="row-divider"></div>

      {/* Second Section */}
      <div className="feature-row">
        <div className="feature-left bold">
          <p>
            Sensación de
            <br />
            espacio.
          </p>
        </div>
        <div className="feature-right light">
          <p>
            La abundante luz natural combinada con una distribución
            <br />
            abierta crea una sensación de espacio y amplitud en el
            <br />
            interior de la vivienda.
          </p>
        </div>
      </div>

      <div className="row-divider"></div>

      {/* Third Section */}
      <div className="feature-row">
        <div className="feature-left light">
          <p>
            Además de sus beneficios funcionales, la cocina abierta y<br />
            los ventanales añaden un estilo contemporáneo y elegante
            <br />
            al diseño de la vivienda.
          </p>
        </div>
        <div className="feature-right bold">
          <p>Estilo Contemporaneo</p>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
